{
  "accent": "Acento",
  "width": "Ancho",
  "showCovers": "Mostrar portadas",
  "showTrackNumber": "Mostrar número de pista",
  "showFileExtension": "Mostrar extensión de archivo",
  "trackInfoAlign": "Alinear información de la pista",
  "trackInfoAlignLeft": "izquierda",
  "trackInfoAlignRight": "derecha"
}
